(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-full-description"] && !Shopify.designMode) return;
  try {
    
 
	jQuery(document).ready(function() {
    jQuery('.cus-content-des ol').click(function() {
        jQuery(this).next().slideToggle('1000');
    })	
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-full-description"] && !Shopify.designMode) return;
  try {
    
 
	jQuery(document).ready(function() {
    jQuery('.cus-content-des ol').click(function() {
        jQuery(this).next().slideToggle('1000');
    })	
})


  } catch(e) { console.error(e); }
})();
})();
